module.exports = __webpack_public_path__ + "media/src/images/icons/flags/australia-11628e068d58cb3202d74df5cd1c5ae9.svg";